import client from './axiosClient';
import { API_ENDPOINTS } from '../constants/apiConstants';

export const login = async (email: string, password: string) => {
  return client.post(API_ENDPOINTS.AUTH.LOGIN, { email, password });
};

export const register = async (
  email: string,
  password: string,
  first_name: string,
  last_name: string,
) => {
  return client.post(API_ENDPOINTS.AUTH.REGISTER, {
    email,
    password,
    first_name,
    last_name,
  });
};

export const forgotPassword = async (email: string) => {
	return client.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
};

export const verifyResetPasswordOTP = async (otp: string) => {
	return client.post(API_ENDPOINTS.AUTH.VERIFY_RESET_PASSWORD_OTP, { otp });
};

export const resetPassword = async (body: any) => {
	return client.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, body);
};

export const getClients = async () => {
  return client.get(API_ENDPOINTS.CLIENTS.GET);
};

export const createClient = async (clientData: object) => {
  return client.post(API_ENDPOINTS.CLIENTS.CREATE, clientData);
};

export const updateClient = async (clientData: object, clientId: any) => {
  return client.put(`${API_ENDPOINTS.CLIENTS.UPDATE}/${clientId}`, clientData);
};

export const deleteClient = async (clientId: number) => {
  return client.delete(`${API_ENDPOINTS.CLIENTS.DELETE}/${clientId}`);
};

export const getClientById = async (clientId: number) => {
  return client.get(`${API_ENDPOINTS.CLIENTS.GET}/${clientId}`);
};
